module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_3.1a67e615.png";